import { useState } from 'react';

import { getLeadSourceImageUrl } from '../../utils/imageUtils';
import { ImageContainer, PlaceholderIcon, StyledImage } from './LeadSourceImage.styles';

const LeadSourceImage = ({ imagePath, alt = 'Lead Source', size = 40 }) => {
  const [imageError, setImageError] = useState(false);
  const imageUrl = getLeadSourceImageUrl(imagePath);

  const handleImageError = () => {
    setImageError(true);
  };

  if (!imageUrl || imageError) {
    return (
      <ImageContainer $size={size}>
        <PlaceholderIcon $size={size}>
          <svg
            width={size * 0.6}
            height={size * 0.6}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21 15L16 10L5 21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </PlaceholderIcon>
      </ImageContainer>
    );
  }

  return (
    <ImageContainer $size={size}>
      <StyledImage src={imageUrl} alt={alt} onError={handleImageError} $size={size} />
    </ImageContainer>
  );
};

export default LeadSourceImage;
